<template>
  <div>
    <h5 class="info-text">List of Incident Report</h5>
    <div class="row justify-content-center mt-5">
      <div class="col-sm-8">
        <el-table
          :data="tableJKKP"
          @selection-change="handleRowChange"
          style="border: solid white; border-radius: 10px"
          :header-cell-style="{
            background: 'transparent',
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
          :cell-style="{
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
        >
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Time of Incident"
            property="inTime"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Date of Incident"
            property="dateOfIncident"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Name of Notifier"
            property="notifierName"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Person Involved"
            property="personInvolved"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Location of Incident"
            property="inLocation"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Type of Incident"
            property="incidentType"
          ></el-table-column>
          <el-table-column type="selection" :min-width="40" align="right">
            <!-- <div slot-scope="props">
              <base-input type="checkbox" :key="props.$index" @click="handleRowChange(props.row)" v-model="tableJKKP.selected" >
                
              </base-input>
            </div> -->
          </el-table-column>
        </el-table>
        <!-- {{tableJKKP.incidentId}} -->
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  data() {
    return {
      data: [],
      tableJKKP: [],
      selected: [],
      model: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
      },
      modelValidations: {
        firstName: {
          required: true,
          min: 5,
        },
        lastName: {
          required: true,
          min: 5,
        },
        email: {
          required: true,
          email: true,
        },
        phone: {
          required: true,
          numeric: true,
        },
        data: [],
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      let dataindex = this.data;
      console.log(dataindex);
      if (dataindex.length === 0) {
        swal({
          title: "please choose at least one!",
          // text: `You deleted ${row.InstName}`,
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      } else {
        return this.$validator.validateAll().then((res) => {
          this.$root.$emit("updateinvestigation", dataindex);
          return res;
        });
      }
    },
    getData() {
      this.$http.get(":9994/api/v1/incident/investigation").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let data = {
              incidentid: parseInt(response[i].IncidentId),
              jkkp: response[i].Jkkp,
              dateOfIncident: response[i].DateOfIncident,
              notifierName: response[i].NameOfNotifier,
              personInvolved: response[i].VictimName,
              incidentType: response[i].IncidentType,
              notifierDesignation: response[i].NotifierDesignation,
              notifierOrg: response[i].NotifierOrg,
              notifierAddr: response[i].NotifierAddr,
              notifierTelNo: response[i].NotifierTelNo,
              notifierRocNo: response[i].NotifierRocNo,
              notifierJkkpRegNo: response[i].NotifierJkkpRegNo,
              otherContact: response[i].OtherContactInfo,
              vicDob: response[i].VicDob,
              vicKp: response[i].VicKp,
              NoPekerja: response[i].NoPekerja,
              vicNation: response[i].VicNation,
              vicSex: response[i].VicSex,
              vicOccupation: response[i].VicOccupation,
              vicOrg: response[i].VicComp,
              vicAge: response[i].VicAge,
              vicTelNo: response[i].VicTelNo,
              vicWorkArea: response[i].VicWorkArea,
              vicWorkScope: response[i].VicWorkScope,
              vicSupervisor: response[i].VicSupervisor,
              vicStartDate: response[i].VicStartDate,
              vicHomeAddr: response[i].VicHomeAddr,
              vehRegNo: response[i].VehRegNo,
              vehType: response[i].VehType,
              vehRtaxDate: response[i].VehRtaxDate,
              vehPuspaDate: response[i].VehPuspaDate,
              noOfMc: response[i].NoOfMc,
              noOfLti: response[i].NoOfLti,
              acClassName: response[i].AcClassName,
              acCauseName: response[i].AcCauseName,
              inLocation: response[i].IncidentLocation,
              vicCompAddr: response[i].VicCompAddr,
              reportDateToJkkp: response[i].ReportDateToJkkp,
              inDetail: response[i].InDetail,
              inTime: response[i].IncidentTime,
              inLocation: response[i].IncidentLocation,
              medicName: response[i].MedicName,
              medicDesignation: response[i].MedicDesignation,
              medicTelNo: response[i].MedicTelNo,
              medicAddr: response[i].MedicCompAddr,
              diagnosis: response[i].Diagnosis,
              diagnosisDate: response[i].DiagnosisDate,
              doctorName: response[i].DoctorName,
              doctorAddr: response[i].DoctorAddr,
              weatherCond: response[0].WeatherCond,
              surrCond: response[0].SurrCond,
              injury: response[0].Injury,
              propDamage: response[0].PropDamage,
              inSummry: response[0].InSummary,
              image: response[i].InImage,
            };
            // console.log(response[0].InImage)
            this.tableJKKP.push(data);
          }
          let incidentdata = this.tableJKKP;
          this.$root.$emit("incident", incidentdata);
        }
      });
    },
    handleRowChange(val) {
      this.data = val;
      console.log(this.data);
      // console.log(data)
      // if (this.selected.includes(data.incidentId)) {
      //   this.selected.splice(this.selected.findIndex(v => v === data.incidentId), 1)
      // } else {
      //   this.selected.push(data.incidentId)
      // }

      // console.log(this.selected)
      // // let tempData = []
      // let dataindex = []
      // dataindex = this.selected
      // // tempData.push(dataindex)
      // console.log(dataindex)
      // this.sendIncidentDetails(dataindex)
    },
    // sendIncidentDetails(dataindex){
    //   this.$root.$emit("updateinvestigation", dataindex)
    // }
  },
};
</script>
<style></style>
